import { eventBus } from '@atc/cai-event-bus';
import debugWallet from './debugWallet.js';
import { WALLET_UPDATE_DATA_AFTER_LOGIN_COMPLETE } from '../constants/events.js';
async function updateDataAfterLogin(walletStorageService) {
  const isLoggedIn = true;
  const consumerid = await walletStorageService.fetchConsumerid(isLoggedIn);
  const localWalletId = walletStorageService.getWalletId();
  debugWallet(`consumerid: ${consumerid}, localWalletId: ${localWalletId}`);
  if (consumerid) {
    // Need local payments info for comparison
    const {
      paymentInfo: localPaymentInfo
    } = await walletStorageService.getDataWithWalletId();
    const localHasUpdatedWallet = localPaymentInfo?.interactions?.hasUpdatedWallet;
    const {
      paymentInfo: paymentsFromConsumerid = {},
      id: idFromConsumerRequest
    } = await walletStorageService.getDataWithConsumerid();
    const hasPaymentsFromConsumerid = Object.keys(paymentsFromConsumerid).length > 0;

    // compare local wallet id with wallet id from consumer response (can be present in two different locations in the response)
    const walletIdFromConsumerRequest = idFromConsumerRequest || paymentsFromConsumerid?.walletId || null;
    const hasMatchingWalletIds = !!(walletIdFromConsumerRequest && localWalletId) && walletIdFromConsumerRequest === localWalletId;
    debugWallet(`locally hasUpdatedWallet: ${localHasUpdatedWallet}, hasMatchingWalletIds: ${hasMatchingWalletIds}`);
    if (!hasMatchingWalletIds) {
      let paymentInfo = localPaymentInfo;
      let action = 'set';
      if (!walletIdFromConsumerRequest) {
        // User doesn't have previous wallet data (walletIdFromConsumerRequest is null or undefined)
        debugWallet('No logged in wallet data found. Using local wallet data instead.');
      } else if (!localHasUpdatedWallet && hasPaymentsFromConsumerid) {
        // User doesn't have local wallet data (but paymentsFromConsumerid is present)
        debugWallet('No local wallet data found. Using logged in wallet data instead.');

        // Use paymentsFromConsumerid as wallet data by default
        paymentInfo = paymentsFromConsumerid;
      } else {
        action = 'update';

        // User has different sets of wallet data (ids don't match)
        debugWallet('Conflicting versions of wallet data found. Launching wallet compare modal.');

        // Save paymentsFromConsumerid as previousePaymentInfo and open wallet modal to compare panel
        paymentInfo = {
          ...paymentInfo,
          hasPreviousPaymentInfo: true,
          previousPaymentInfo: {
            ...paymentsFromConsumerid
          },
          hasWalletDataToCompare: true,
          myWallet: {
            ...paymentInfo.myWallet,
            displayModal: true,
            selectedPanelName: 'compareWalletData'
          }
        };
      }
      debugWallet('wallet data after login is complete: ', paymentInfo);
      eventBus.emit(WALLET_UPDATE_DATA_AFTER_LOGIN_COMPLETE, {
        paymentInfo,
        action
      });
    } else {
      // Wallet ids match and the data is in sync
      debugWallet('No changes needed after login. Wallet data is in sync.');
    }
  }
}
export { updateDataAfterLogin as default };
